import { EVENTS } from "../../Tracking";
import { MenuListItem } from "@teamscheme/header-elements";
import StaticRoutes from "../../static-pages/StaticRoutes";
import { useCustomer } from "../../auth/CustomerProvider";
import { useBecomeMemberPath } from "../../membership/MembershipPaymentParameters";
import { useMemo } from "react";

export interface OrderedMenuListItem extends MenuListItem {
  order: number;
}

export type MaybeOrderedMenuListItem = MenuListItem | OrderedMenuListItem;

export function useStaticBecomeMemberMenuItem(): MaybeOrderedMenuListItem | null {
  const customer = useCustomer();
  return useMemo(() => {
    if (customer.isLoading) return null;
    if (customer.result?.hasMembership) return null;
    return {
      key: "become-member",
      text: "Bli medlem",
      linkTo: StaticRoutes.becomeMember.path,
    };
  }, [customer.isLoading, customer.result]);
}

export function useFlowBecomeMemberMenuItem(): MaybeOrderedMenuListItem | null {
  const customer = useCustomer();
  const linkTo = useBecomeMemberPath();

  return useMemo(() => {
    if (customer.isLoading) return null;
    if (customer.result?.hasMembership) return null;

    return {
      key: "become-member",
      text: "Bli medlem",
      linkTo,
    };
  }, [customer.isLoading, customer.result, linkTo]);
}

export function createFaqLinkItem(): MaybeOrderedMenuListItem {
  const props: MenuListItem = {
    key: "FAQ",
    text: "Vanlige spørsmål",
    linkTo: StaticRoutes.faq.path,
    trackEvent: EVENTS.HEADER.FAQ,
  };
  return props;
}

export function useFaqLinkItem() {
  return useMemo(() => createFaqLinkItem(), []);
}

export function createAboutLinkItem(): MaybeOrderedMenuListItem {
  const props: MenuListItem = {
    key: "About",
    text: "Slik fungerer det",
    linkTo: StaticRoutes.howItWorks.path,
    trackEvent: EVENTS.HEADER.FAQ,
  };
  return props;
}

export function useAboutLinkItem() {
  return useMemo(() => createAboutLinkItem(), []);
}

export function combineMenuItems(
  items: (MaybeOrderedMenuListItem | null)[]
): OrderedMenuListItem[] {
  const filtered = items.filter((e): e is MaybeOrderedMenuListItem => !!e);

  return filtered
    .map((x, index) => {
      if ("order" in x) {
        const { order, ...rest } = x;
        return { order: index + order * filtered.length, ...rest };
      }

      return { order: index, ...x };
    })
    .sort((a, b) => a.order - b.order);
}
